import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { log } from 'src/app/utils/logging';
import { actionUpdateSourceJobId } from 'src/app/v1/state/modules/session/sourceJobId';
import { actionUpdateSeekListingId } from 'src/app/v1/state/modules/tealium/seekListingId';
import { actionUpdateSourceJobId as actionUpdateTealiumSourceJobId } from 'src/app/v1/state/modules/tealium/sourceJobId';
import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';
import { useQueryParams } from 'src/app/v1/views/hooks/useQueryParams';
import type { AppState } from 'src/types/appState';

export const useJobId = () => {
  const { isDataCleanupComplete, flowType, seekListingId, sourceJobId } =
    useSelector(
      (state: AppState) => ({
        flowType: state.formData.flowType,
        isDataCleanupComplete: state.app.isDataCleanupComplete,
        seekListingId: state.tealium.seekListingId,
        sourceJobId: state.session.sourceJobId,
      }),
      shallowEqual,
    );
  const dispatch = useDispatch();
  const { getJobIdParam } = useQueryParams();
  const { redirectToDashboard } = useLocalisedRoutes();

  useEffect(() => {
    const jobIdParam = getJobIdParam();

    const isEditOrRefreshFlowType =
      flowType === 'edit' || flowType === 'refresh';

    if (isEditOrRefreshFlowType && !jobIdParam && !sourceJobId) {
      log.error('useJobId | job id missing', { seekListingId, flowType });
      return redirectToDashboard();
    }

    if (jobIdParam) {
      if (isDataCleanupComplete) {
        if (!sourceJobId) {
          dispatch(actionUpdateSourceJobId(jobIdParam));
          dispatch(actionUpdateTealiumSourceJobId(jobIdParam));
        }

        if (isEditOrRefreshFlowType && !seekListingId) {
          dispatch(actionUpdateSeekListingId(jobIdParam));
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flowType, isDataCleanupComplete, seekListingId, sourceJobId]);
};
